const DEFAULT_LANGUAGE = "no-NO";

const getLanguage = (): string =>
  document?.documentElement?.lang || DEFAULT_LANGUAGE;

export const formatToLocaleString = (value: number): string =>
  value.toLocaleString(getLanguage());
